module.exports = __webpack_public_path__ + "static/media/web.ce895793.svg";